module.exports = __webpack_public_path__ + "img/Doc17b_Lillian_Freiman_at_desk.9c68e988.jpg";